// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container[data-v-045e3054]{height:100%;overflow:hidden;display:flex;flex-direction:column;position:relative}.container .cv-dtm[data-v-045e3054]{margin-bottom:5px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
